module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/symbolsJ109@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/symbolsJ109@3x.png
// module id = 724
// module chunks = 0